<div
  [ngClass]="file.documentId ? 'pointer-style' : ''"
  class="file"
  (click)="file.documentId && downloadFile()"
>
  <img [src]="'/assets/icon/doc-types/' + getIconForExtension(extension) + '.svg'" />
  {{ file.name }}
</div>
